import { render } from "./apButton.vue?vue&type=template&id=616a64ac&scoped=true"
import script from "./apButton.vue?vue&type=script&lang=js"
export * from "./apButton.vue?vue&type=script&lang=js"

import "./apButton.vue?vue&type=style&index=0&id=616a64ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616a64ac"]])

export default __exports__